
import { Component, Prop, Vue } from 'vue-property-decorator';
import B2BDeliverySection from '@/components/views/ClientView/B2BDeliverySection.vue';
import AddressLocationFields from '@/components/views/ClientView/AddressLocationFields.vue';
import CountryRepository from '@/repositories/CountryRepository';

interface B2BDeliveryData {
    phoneNumber: string;
    email: string;
    notes: string;
    deliveryDays: string[];
    languageCode: string;
    printRegion: string;
    deliverySchedule: string[];
    deliveryRegion: string;
}

@Component({
    name: 'ClientAddressForm',
    components: {
        B2BDeliverySection,
        AddressLocationFields,
    },
})
export default class ClientAddressForm extends Vue {
    @Prop({ default: null }) private value!: any;
    @Prop({ default: null }) private filteredAddressTypes!: any[];
    @Prop({ default: false }) private isContactAddress!: boolean;
    @Prop({ required: true }) private canAccessLogistics!: boolean;

    private onB2BDeliveryChange(payload: { isB2BDelivery: boolean; data: B2BDeliveryData }) {
        const { isB2BDelivery, data } = payload;
        this.value.b2bDeliveryPhone = isB2BDelivery ? data.phoneNumber : '';
        this.value.b2bDeliveryEmail = isB2BDelivery ? data.email : '';
        this.value.b2bDeliveryNotes = isB2BDelivery ? data.notes : '';
        this.value.languageCode = isB2BDelivery ? data.languageCode : '';
        this.value.printRegion = isB2BDelivery ? data.printRegion : '';
        this.value.b2bDeliveryDays = isB2BDelivery ? (data.deliveryDays?.length ? data.deliveryDays : []) : [];
        this.value.b2bDeliverySchedule = isB2BDelivery ? data.deliverySchedule : '';
        this.value.b2bDeliveryRegion = isB2BDelivery ? data.deliveryRegion : '';
        this.$emit('input', this.value);
    }

    get countries() {
        return CountryRepository.getAll();
    }

    get internalCodeOptions() {
        const seen = new Set();
        const options: { code: string; label: string }[] = [];
        this.countries
            .filter((c) => c.internalCode && c.internalCode !== 'null' && c.internalCode !== '')
            .forEach((c) => {
            if (!seen.has(c.internalCode)) {
                seen.add(c.internalCode);
                options.push({ code: c.internalCode, label: `${c.internalCode}` });
            }
            });
        return options.sort((a, b) => a.code.localeCompare(b.code));
    }

    get languageOptions() {
        const seen = new Set();
        const options: { code: string; label: string }[] = [];
        this.countries
            .filter(
            (c) =>
                c.languageCode &&
                c.languageCode !== 'null' &&
                c.languageCode !== '' &&
                c.internalCode &&
                c.internalCode !== 'null' &&
                c.internalCode !== ''
            )
            .forEach((c) => {
            if (!seen.has(c.code)) {
                seen.add(c.code);
                options.push({ code: c.languageCode, label: `${c.languageCode} - ${c.code.toUpperCase()}` });
            }
            });
        return options.sort((a, b) => a.label.localeCompare(b.label));
    }

    get regionOptions() {
        const regions = this.countries.map((c) => c.printRegion).filter((val) => val && val !== 'null' && val !== '');
        return [...new Set(regions)].sort();
    }
}
